module.exports = __webpack_public_path__ + "img/xprinter.1f65067d.png";